import React, { useState, useEffect, useCallback } from "react";
import useAxiosPrivate from "../../hooks/useAxiosPrivate";
import { useNavigate } from "react-router-dom";
import logo from "../../assets/yapa-logo.png";
import "./OtherList.css";

const OtherList = () => {
    const [items, setItems] = useState<string[]>([]);
    const [filteredItems, setFilteredItems] = useState<string[]>([]);

    const axiosPrivate = useAxiosPrivate();
    const navigate = useNavigate();

    const getEventsType = useCallback(async () => {
        try {
            const response = await axiosPrivate.get("/eventsType/names");
            const eventTypes = response.data.map((event: { nazwa: string }) => event.nazwa);
            setItems(eventTypes);
            setFilteredItems(eventTypes);
        } catch (error) {
            console.error("Błąd podczas pobierania typów wydarzeń:", error);
            setItems([]);
            setFilteredItems([]);
        }
    }, [axiosPrivate]);

    useEffect(() => {
        getEventsType();
    }, [getEventsType]);

    const handleEdit = (eventName: string) => {
        sessionStorage.setItem("editEventName", eventName); // Zapisz nazwę do sessionStorage
        navigate("/editOtherType");
    };

    const handleDelete = async (name: string) => {
        const confirmDelete = window.confirm(`Czy na pewno chcesz usunąć typ wydarzenia: ${name}?`);
    
        if (confirmDelete) {
            try {
                // Zakodowanie nazwy w URL, aby uniknąć problemów ze spacjami i znakami specjalnymi
                const encodedName = encodeURIComponent(name);
    
                const response = await axiosPrivate.delete(`/eventsType/name/${encodedName}`);
    
                if (response.status === 200) {
                    // Usunięcie z listy tylko jeśli operacja zakończyła się sukcesem
                    const updatedItems = items.filter(item => item !== name);
                    setItems(updatedItems);
                    setFilteredItems(updatedItems);
                }
            } catch (error: any) {
                // Obsługa błędu (np. jeśli typ wydarzenia jest powiązany z tabelą Wydarzenia)
                if (error.response && error.response.status === 400 && error.response.data.message) {
                    alert(error.response.data.message);
                } else {
                    console.error("Błąd podczas usuwania typu wydarzenia:", error);
                }
            }
        }
    };
    
    

    return (
        <div className="events-container">
            <div>
                <img src={logo} alt="Yapa Logo" className="logo" />
                <h1>TYPY WYDARZEŃ 🎭</h1>
                <div className="table-actions-container">
                    <div className="table-container">
                        <table className="events-table">
                            <thead>
                                <tr>
                                    <th>Typ wydarzenia</th>
                                    <th>Edycja i usuwanie</th>
                                </tr>
                            </thead>
                            <tbody>
                                {filteredItems.map((event, index) => (
                                    <tr key={index} className={index % 2 === 0 ? "even-row" : "odd-row"}>
                                        <td>{event}</td>
                                        <td>
                                            <button
                                                className="btn icon-btn"
                                                onClick={() => handleEdit(event)}
                                            >
                                                ✏️
                                            </button>
                                            <button
                                                className="btn icon-btn"
                                                onClick={() => handleDelete(event)}
                                            >
                                                🗑️
                                            </button>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                    <div className="actions">
                        <button className="btn" onClick={() => navigate(-1)}>
                            Wróć
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default OtherList;
